import { treeToList } from '@/utils';
import { Suspense, useLayoutEffect, useMemo } from 'react';
import { Route, Routes } from 'react-router-dom';
import routes from './index';
import Loading from '@/components/Loading';

const generateRoute = ({
  routes,
  path,
  component: Component,
  tabBars,
  ...other
}: any) => {
  const hasFallback = other.title == 'Payment';
  return (
    <Route
      path={path}
      key={path}
      element={
        <Suspense fallback={hasFallback ? <Loading /> : null}>
          <Component />
        </Suspense>
      }
      {...other}
    />
  );
};

const handler = (e: any) => {
  e.stopPropagation();
  e.preventDefault();
};

const RouteRender = () => {
  const routesView = useMemo(() => {
    return routes.map((v) => generateRoute(v));
  }, []);

  useLayoutEffect(() => {
    document.removeEventListener('click', handler, true);
  }, []);

  const routeList = treeToList(routes, ['routes']);
  document.title =
    routeList.find((v) => v.path === location.pathname)?.title ||
    document.title;

  return <Routes location={location}>{routesView}</Routes>;
};
export default RouteRender;
